import { render, staticRenderFns } from "./OrdersIncidentMessageModal.vue?vue&type=template&id=4f8a9bc6&"
import script from "./OrdersIncidentMessageModal.vue?vue&type=script&lang=js&"
export * from "./OrdersIncidentMessageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports